import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { useMemo } from "react";

import { TextTooltip } from "@transfr-inc/dashboard-components";

import "./income-rate.scss";

const IncomeRateValues = [
  {
    hourlyPay: 35,
    description: "Very high",
    rate: 4,
  },
  {
    hourlyPay: 25,
    description: "High",
    rate: 3,
  },
  {
    hourlyPay: 15,
    description: "Medium",
    rate: 2,
  },
  {
    hourlyPay: 0,
    description: "Low",
    rate: 1,
  },
];

const getHourlyRateObject = (value) => {
  return IncomeRateValues.find((rate) => value >= rate.hourlyPay);
};

export const IncomeRate = ({ value }) => {
  const { description, rate } = getHourlyRateObject(value);
  const incomeRateDescription = `${description} salary compared with other careers.`;

  const rateIcons = useMemo(() => {
    return Array.from({ length: rate }).map((_, index) => (
      <FontAwesomeIcon
        key={`coin-icon.${index}`}
        icon={["fa-regular", "circle-dollar"]}
      />
    ));
  }, [rate]);

  return (
    <div className="income-rate-container">
      <TextTooltip text={incomeRateDescription}>
        <div className="income-rate-icons">{rateIcons}</div>
      </TextTooltip>
    </div>
  );
};

IncomeRate.displayName = "Income Rate";

IncomeRate.propTypes = {
  value: PropTypes.number,
};
